import { useEffect, useState, type FormEvent } from 'react';
import { italianNationalNumber } from '../lib/identity';
import { acceptInviteFromLink, getInvitePreview } from '../lib/inviteAccess';
import { supabase } from '../lib/supabase';

export function InviteLinkForm({
  token,
  onAccepted,
}: {
  token: string;
  onAccepted: () => Promise<void>;
}) {
  const [number, setNumber] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [instrument, setInstrument] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [setlistTitle, setSetlistTitle] = useState('');
  useEffect(() => {
    let active = true;
    void getInvitePreview(supabase, token).then((preview) => {
      if (active) setSetlistTitle(preview?.setlist_title ?? '');
    });
    return () => {
      active = false;
    };
  }, [token]);
  async function submit(event: FormEvent) {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      await acceptInviteFromLink(supabase, {
        token,
        displayName,
        nationalNumber: number,
        instrument,
      });
      await onAccepted();
    } catch (failure) {
      setError(friendlyInviteError(failure));
    } finally {
      setBusy(false);
    }
  }
  return (
    <form onSubmit={submit}>
      <h2>{setlistTitle ? `Invito a “${setlistTitle}”` : "Accetta l'invito"}</h2>
      <p>
        {setlistTitle
          ? `Sei stato invitato a collaborare alla scaletta “${setlistTitle}”. `
          : ''}
        Inserisci il nome che vuoi mostrare, il tuo numero e lo strumento che suoni.
      </p>
      <label>
        Nome visualizzato
        <input
          value={displayName}
          onChange={(event) => setDisplayName(event.target.value)}
          autoComplete="name"
          required
        />
      </label>
      <label>
        Numero di telefono
        <span className="phone-field">
          <strong>+39</strong>
          <input
            type="tel"
            inputMode="numeric"
            autoComplete="tel-national"
            value={number}
            onChange={(event) => setNumber(italianNationalNumber(event.target.value))}
            placeholder="333 1234567"
            pattern="[0-9 ]*"
            required
          />
        </span>
      </label>
      <label>
        Strumento musicale
        <input
          value={instrument}
          onChange={(event) => setInstrument(event.target.value)}
          autoComplete="off"
          required
        />
      </label>
      {error && <p className="notice">{error}</p>}
      <button type="submit" disabled={busy}>
        {busy ? 'Controllo…' : 'Accetta invito'}
      </button>
    </form>
  );
}
function friendlyInviteError(failure: unknown) {
  const message = failure instanceof Error ? failure.message : '';
  if (message.includes('phone mismatch')) return "Il numero non corrisponde all'invito.";
  if (message.includes('invite unavailable'))
    return 'Il link è scaduto, revocato o già utilizzato.';
  if (message.includes('display name required')) return 'Indica il nome visualizzato.';
  if (message.includes('instrument required')) return 'Indica lo strumento musicale.';
  return "Non è stato possibile completare l'accesso. Riprova.";
}
